import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import VueI18n from 'vue-i18n'
import { messages } from './locales'
import router from './router.ts'
import store from './store'
import JavascriptAPI from '@/utils/JavascriptAPI'
import { generateFontConfig } from '@/utils/helpers'
import WebFont from 'webfontloader'
import iframeResize from '@/utils/iframeResizer.min'

console.log(iframeResize)

declare global {
  interface Window {
    iframeResize: any
  }
}

Vue.config.productionTip = false
Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: store.state.context.config.locale,
  fallbackLocale: 'sv_SE',
  messages
})

const locale = () => store.state.context.config.locale || 'en'

i18n.locale = locale()

// Change lang dynamically
store.watch(
  () => {
    i18n.locale = locale()
  }, null
)

Vue.directive('resize', {
  bind: function (el, { value = {} }) {
    el.addEventListener('load', () => iframeResize(value, el))
  }
})

Vue.config.ignoredElements = [/^ion-/]

const fontConfig = generateFontConfig(window.location.search)
if (fontConfig) {
  WebFont.load(fontConfig)
}

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')

JavascriptAPI.__API__()
